module.exports = "https://coursera_assets.s3.amazonaws.com/images/b126b8614bc29ee67d07463a52eea686.png";